const compareObjectsBilaterally = (left, right) =>
    Object.keys(left).map((key) => left[key] || right[key]) || Object.keys(right).map((key) => right[key] || left[key]);

export default compareObjectsBilaterally;
